export function parseBillingPeriodValue(value: string): { month: number; year: number } {
  const normalized = value.replace(/^Tháng\s+/i, '').trim();
  const [monthStr, yearStr] = normalized.split('/');
  const month = parseInt(monthStr, 10);
  const year = parseInt(yearStr, 10);
  if (!month || !year) {
    const now = new Date();
    return { month: now.getMonth() + 1, year: now.getFullYear() };
  }
  return { month, year };
}

export function formatBillingPeriodValue(month: number, year: number): string {
  return `${String(month).padStart(2, '0')}/${year}`;
}

export function getCurrentBillingPeriodValue(): string {
  const now = new Date();
  return formatBillingPeriodValue(now.getMonth() + 1, now.getFullYear());
}

/** Calendar month for a billing period (`MM/YYYY` → `YYYY-MM-DD` from/to). */
export function billingPeriodToDateRange(period: string): { dateFrom: string; dateTo: string } {
  const { month, year } = parseBillingPeriodValue(period);
  const lastDay = new Date(year, month, 0).getDate();
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    dateFrom: `${year}-${pad(month)}-01`,
    dateTo: `${year}-${pad(month)}-${pad(lastDay)}`,
  };
}

export const BILLING_PERIOD_MONTH_LABELS = [
  'Th.1', 'Th.2', 'Th.3', 'Th.4', 'Th.5', 'Th.6',
  'Th.7', 'Th.8', 'Th.9', 'Th.10', 'Th.11', 'Th.12',
];
